let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("azMOH")]).then(() => parcelRequire('iUdxh'));